<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <span 
            matTooltip="Export to Excel" 
            matTooltipPosition="left" 
            matTooltipClass="custom-orange-tooltip">
            <app-print-button (togglePrint)="print()"></app-print-button>
        </span>
    </app-tab-header>

    <div class="w-900-px mx-auto">
        <form [formGroup]="form">
            <!-- Row 1: Transaction ID, Phone Number, Product ID -->
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Transaction ID:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="transactionId"
                            type="text"
                            placeholder="Transaction ID">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-141-px font-semibold">Phone Number:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="phoneNumber"
                            type="text"
                            placeholder="Phone Number">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-130-px font-semibold">Product ID:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="productId"
                            type="text"
                            placeholder="Product ID">
                    </div>
                </div>
            </div>

            <!-- Row 2: First Name, Middle Name, Last Name -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-100-px font-semibold">First Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="firstName"
                            type="text"
                            placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-120-px font-semibold">Middle Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="middleName"
                            type="text"
                            placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-100-px font-semibold">Last Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="lastName"
                            type="text"
                            placeholder="Last Name">
                    </div>
                </div>
            </div>

            <!-- Row 3: Date From, Date To (centred) -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-2"></div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input
                            class="w-full"
                            label="Date From:"
                            [parentForm]="form"
                            controlName="dateFrom">
                        </app-date-input>
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <app-date-input
                            class="w-full"
                            label="Date To:"
                            [parentForm]="form"
                            controlName="dateTo">
                        </app-date-input>
                    </div>
                </div>
                <div class="col-span-2"></div>
            </div>

            <!-- Row 4: Item Type, Status (centred) -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-2"></div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-80-px font-semibold">Item Type:</span>
                        <app-dropdown-field
                            [options]="itemTypeOptions"
                            [selectedText]="itemType_text"
                            placeholder="== Select an option =="
                            (selectionChange)="setItemType($event.label, $event.value)">
                        </app-dropdown-field>
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-80-px font-semibold">Status:</span>
                        <app-dropdown-field
                            [options]="statusOptions"
                            [selectedText]="statusType_text"
                            placeholder="== Select an option =="
                            (selectionChange)="setStatusType($event.label, $event.value)">
                        </app-dropdown-field>
                    </div>
                </div>
                <div class="col-span-2"></div>
            </div>
        </form>

        <!-- Submit Button -->
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button
                (click)="submit()"
                class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
    </div>

    <!-- Data Table Section -->
    <div *ngIf="showTable">
        <div *ngIf="submitted">
            <app-table-controls
                [currentLimit]="size"
                [searchPlaceholder]="'Search'"
                (limitChangeEvent)="onLimitChangeFromComponent($event)"
                (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                (keydownEvent)="keyDownFunction($event)">
            </app-table-controls>

            <app-data-table
                [tableSubHeader]="tableSubHeader"
                [isLoading]="isLoading"
                [sort_type]="sort_type"
                (toggleOnSort)="sortList($event.key, $event.type)">
                <tr class="focus:outline-none" *ngFor="let item of itemLists">
                    <td>{{ item.transactionId | nullWithDefault }}</td>
                    <td>{{ item.name | nullWithDefault | titlecase }}</td>
                    <td>{{ item.phoneNumber | nullWithDefault }}</td>
                    <td>{{ item.recipientNumber | nullWithDefault }}</td>
                    <td>{{ item.productId | nullWithDefault }}</td>
                    <td>{{ item.networkProvider | nullWithDefault }}</td>
                    <td>{{ item.loadProvider | nullWithDefault }}</td>
                    <td>{{ item.amount | nullWithDefault | number:'1.2-2' }}</td>
                    <td>{{ item.dateTime | nullWithDefault | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    <td>{{ item.status | nullWithDefault }}</td>
                    <td>{{ item.traceNo | nullWithDefault }}</td>
                    <td>{{ item.itemType | nullWithDefault }}</td>
                    <td>{{ item.modifiedDateTime | nullWithDefault | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    <td>
                        <ng-container *ngIf="containsNumbers(item.buyloadErrorMsg); else stringStatus">
                            Successful
                        </ng-container>
                        <ng-template #stringStatus>
                            {{ item.buyloadErrorMsg }}
                        </ng-template>
                    </td>

                    <!-- ── ACTIONS column ── -->
                    <td>
                        <div class="flex justify-center">
                            <ng-container *ngIf="getRefundButtonState(item) as btnState">
                                <span
                                    [matTooltip]="btnState.tooltip"
                                    [matTooltipDisabled]="!btnState.tooltip"
                                    matTooltipPosition="left">
                                    <button
                                        class="custom-btn action-btns focus:outline-none"
                                        style="width: 100px; height: 23px;"
                                        [disabled]="btnState.disabled"
                                        [style.cursor]="btnState.disabled ? 'not-allowed' : 'default'"
                                        (click)="openRefundConfirmation(item)">
                                        <ng-container *ngIf="refundingTransactionId === item.transactionId; else refundLabel">
                                            Refunding…
                                        </ng-container>
                                        <ng-template #refundLabel>Refund</ng-template>
                                    </button>
                                </span>
                            </ng-container>
                        </div>
                    </td>
                </tr>
            </app-data-table>

            <!-- Empty state (only shown after loading completes) -->
            <div *ngIf="!isLoading && (!itemLists || itemLists.length === 0)"
                class="bg-light-orange w-full py-3 text-gray-500"
                style="text-align: center; border-bottom: 1px solid #d1d5db;">
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;">
                    <img src="../../../../assets/images/icon/no-data.webp"
                        alt="No Data"
                        style="height: 48px; opacity: 0.4;"
                        onerror="this.style.display='none'">
                    <span class="font-semibold text-xs uppercase tracking-wide">No records found</span>
                    <span class="italic text-xs">Try adjusting your search or filter criteria.</span>
                </div>
            </div>

            <app-pagination
                [currentPage]="current_page"
                [totalPages]="total_pages"
                [pageSize]="size"
                [totalItems]="total"
                (pageChange)="setPage($event)"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                showTotalEntries="true">
            </app-pagination>
        </div>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>